<template>
  <vs-popup
    :active.sync="isSidebarActiveLocal"
    v-esc="escape"
    title="Yemeksepeti Excel Dosya Yükleme"
  >
    <div>
      <p>
        <strong>Yemeksepeti Excel Dosya Yükleme</strong>
      </p>
      <input type="file" @change="(e) => (file = e.target.files[0])" />
      <vs-button @click="uploadFile" :disabled="!file">Dosya yükle</vs-button>
    </div>
  </vs-popup>
</template>
<script>
import { excelUpload } from "@/api/Integration";
export default {
  data() {
    return {
      file: null,
    };
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    integrationId: {
      type: String,
      required: true,
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar", false);
          this.$validator.reset();
        }
      },
    },
  },
  methods: {
    escape() {
      if (this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
    },
    async uploadFile() {
      const formData = new FormData();
      console.log(this.file);
      console.log(this.integrationId);
      formData.append("file", this.file);
      await excelUpload(this.integrationId, formData)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Dosya başarıyla yüklendi.",
            text: "Menüyü güncellendi.",
          });

          this.$emit("getProducts", true);
          this.$emit("closeSidebar", false);
        })
        .catch((error) => {
          console.error("Excel yükleme hatası:", error);
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Dosya yüklenirken bir hata oluştu.",
          });
        });
    },
  },
};
</script>
